<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>賃居公告</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
					<a href="/">
						<i class="fa fa-home"></i>
					</a>
					</li>
					<li><span>賃居公告</span></li>
				</ol>
			</div>
		</header>
		<div class="main">
			<header class="panel-heading">
				<h3 class="panel-title">賃居公告訊息</h3>
			</header>
			<section class="panel panel-default" style="margin-bottom: 0px;">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a id="openSearch" href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">查詢條件</h4>
				</header>
				<div id="searchArea" class="panel-collapse collapse">
					<div class="panel-body">
						<div class="row form-group">
							<div class="col-md-12 ">
								<div class="col-md-6">
									<label class="col-md-4">關鍵字查詢</label>
									<div class="col-md-8">
										<input type="text" v-model="hotKey" class="form-control"/>
									</div>
								</div>
								<div class="col-md-6"></div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-offset-4 col-md-4 ">
								<div class="col-md-offset-4 col-md-4">
									<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<div class="tab-content">
				<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
					<div class="row form-group" v-if="isAdmin('tenancy')">
						<div class="col-md-12 text-right form-inline">
							<a href="javascript:;" @click="gotoView('/tenancy-news/detail',{isEdit:'Y'})" class="btn btn-danger">新增賃居公告</a>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12">
							<table class="table table-no-more table-bordered table-striped mb-none" >
									<thead>
										<tr>
											<th class="text-center" width="5%" v-if="isAdmin('tenancy')">刪除</th>
											<th class="text-center" width="15%">公告日期</th>
											<th class="text-center" width="70%">標題</th>
											<!-- <th class="text-center" width="15%">發佈</th> -->
											<th class="text-center" width="10%" v-if="isAdmin('tenancy')">閱讀名單</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in newsList" :key="index">
											<td v-if="isAdmin('tenancy')" class="text-center" data-title="">
												<a href="javascript:;" class="btn-link" @click="deleteNews(item.id)">刪除</a>
											</td>
											<td class="text-center" data-title="公告日期">{{customFormatter(item.newsBeginDate)}}~{{customFormatter(item.newsEndDate)}}</td>
											<td data-title="標題">
												<a href="javascript:;" class="btn-link" @click="gotoView('/tenancy-news/detail', {isEdit:'N',id:item.id})">{{item.title}}</a>
											</td>
											<!-- <td class="text-center">[{{item.publishUnit}}]{{item.publishUser}}&emsp;{{item.crDateCht}}發佈</td> -->
											<td v-if="isAdmin('tenancy')" class="text-center" data-title="閱讀名單">
												<a href="javascript:;" class="btn-link" @click="newsId= item.id; showPopup=true;">查看</a>
											</td>
										</tr>
									</tbody>
								</table>
						</div>
						<div class="col-md-12">
							<div class="text-center" v-if="isAdmin('stay')">
								<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
							</div>
						</div>
					</div>
				</div>
			</div>

			<popReaders :id="newsId" v-if="showPopup"></popReaders>
		</div>
	</section>
</template>
<script>
import popReaders from './popReaders';
export default {
	components:{
		popReaders
	},
	data(){
		return {
			page:1,
			pageSize:10,
			totalPage:0,
			newsList:[],
			hotKey:"",
			showPopup:false,
			newsId:"",
		};
	},
	mounted(){
		this.updateGrid(1);
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			let param = {
				page:this.page,
				pageSize:this.pageSize,
				model:{
					hotKey:this.hotKey
				}
			};
			const api = "/api/News/tenancyNewsGrid";
			this.$axios.post(api, JSON.stringify(param)).then(resp =>{
				this.newsList = resp.data.data.rows;
				this.totalPage = resp.data.data.total
				this.page = resp.data.data.page;
				this.pageSize = resp.data.data.pageSize;
			});
		},
		deleteNews(id){
			let _this = this;
			bootbox.confirm("是否刪除此筆公告", function(result){
				if(result){
					const api = "/api/News/deleteNews/"+id;
					_this.$axios.delete(api).then(resp => {
						if(resp.data.status == "success"){
							_this.gridInit();
						}
					});
				}
			});
		},
		showPopupControl(isOpen){
			this.showPopup = isOpen;
		}
	}
}
</script>